import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

export class TheCryptFSBetPresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController) {
        flowStateController.finish();
    }
}